import { useEffect, useState } from "react"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import { postCandidateCompliance, getCandidateCompliances } from "@/api/candidate/candidateCompliances.jsx"
import FileUpload from "@/components/FileUpload.jsx"
import { Loader } from "@/components/ui/loader"
import {BackButton} from "@/components/ui/BackButton.jsx";

export default function ComplianceForm() {
    const [complianceTypes, setComplianceTypes] = useState([])
    const [uploads, setUploads] = useState({})
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        async function load() {
            try {
                const res = await getCandidateCompliances()
                setComplianceTypes(res)
            } catch (err) {
                console.error("Failed to load compliances", err)
            } finally {
                setLoading(false)
            }
        }
        load()
    }, [])

    const handleFileChange = (typeId, file) => {
        setUploads((prev) => ({ ...prev, [typeId]: file }))
    }

    const handleUpload = async (typeId) => {
        const file = uploads[typeId]
        if (!file) return

        try {
            const res = await postCandidateCompliance(typeId, file)

            setComplianceTypes((prev) =>
                prev.map((item) =>
                    item.id === typeId
                        ? { ...item, candidateCompliance: res.complianceDocument }
                        : item
                )
            )

            setUploads((prev) => {
                const updated = { ...prev }
                delete updated[typeId]
                return updated
            })
        } catch (err) {
            console.error("Upload error:", err)
            alert("Failed to upload. Please try again.")
        }
    }

    if (loading) return <Loader />

    return (
        <div className="space-y-6  p-3 bg-brand-25">
            <BackButton to="/profile/candidate" />
            {complianceTypes.map((type) => {
                const existingDoc = type.candidateCompliance?.fileExists
                const documentUrl = type.candidateCompliance?.documentUrl

                return (
                    <div key={type.id} className="space-y-6 bg-white p-4 rounded-xl shadow-sm border">
                        <Label className="block font-medium text-base">{type.name}</Label>

                        {existingDoc ? (
                            <Button
                                className="bg-brand-500"
                                size="sm"
                                onClick={() => window.open(documentUrl, "_blank")}
                            >
                                View Document
                            </Button>
                        ) : (
                            <div className="space-y-2">
                                <FileUpload onSelect={(file) => handleFileChange(type.id, file)} />

                                {uploads[type.id] && (
                                    <div className="flex items-center gap-4 pt-1">
                                        {uploads[type.id].type.startsWith("image/") ? (
                                            <img
                                                src={URL.createObjectURL(uploads[type.id])}
                                                alt="Preview"
                                                className="h-16 rounded border"
                                            />
                                        ) : (
                                            <span className="text-sm text-muted-foreground">
                        {uploads[type.id].name}
                      </span>
                                        )}

                                        <Button
                                            size="sm"
                                            className="bg-brand-500"
                                            onClick={() => handleUpload(type.id)}
                                        >
                                            Upload
                                        </Button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )
            })}

            <p className="text-sm text-muted-foreground pt-6">
                To update an existing document, please contact your account manager.
            </p>
        </div>
    )
}
